<template>
  <UtilityAnnouncementStripe
    :visible="visible"
    :region-label="$t('betaUpdate.region')"
    :dismiss-label="$t('betaUpdate.dismiss')"
    :sidebar="sidebar"
    test-id="beta-update-announcement"
    dismiss-test-id="beta-update-dismiss"
    beta
    @dismiss="persistDismissal"
    @collapsed="visible = false"
  >
    <!-- Ben 2026-10-03: a company announcement, so his exact words, not her voice. -->
    <strong class="beta-update__lead">{{ `${$t('betaUpdate.label')} ` }}</strong>
    <span class="beta-update__message">{{ $t('betaUpdate.message') }}</span>
  </UtilityAnnouncementStripe>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import UtilityAnnouncementStripe from './UtilityAnnouncementStripe.vue';
import { claimBetaUpdateVisit, dismissBetaUpdate } from '~/utils/beta-update-announcement';

const props = withDefaults(
  defineProps<{
    accountUid: string | null;
    createdAt: string | null;
    impersonating?: boolean;
    /** Design specimens only: always shown, and closing it persists nothing. */
    preview?: boolean;
    /** The desktop sidebar occupies the stripe's left edge. */
    sidebar?: 'none' | 'expanded' | 'collapsed';
  }>(),
  { impersonating: false, preview: false, sidebar: 'none' }
);

const visible = ref(false);
let mounted = false;

// Storage is browser-only, so decide after mount and when account metadata arrives.
function evaluate(): void {
  if (!mounted || visible.value) return;
  visible.value =
    props.preview ||
    claimBetaUpdateVisit({
      accountUid: props.accountUid,
      createdAt: props.createdAt,
      impersonating: props.impersonating
    });
}

onMounted(() => {
  mounted = true;
  evaluate();
});
watch(() => [props.accountUid, props.createdAt, props.impersonating], evaluate);

function persistDismissal(): void {
  if (!props.preview) dismissBetaUpdate(props.accountUid);
}
</script>

<style scoped lang="scss">
.beta-update__lead {
  font-weight: 700;
}
</style>
